/**
 * Normalize HTTP status from SDK ApiError, axios, or @repo/http-client errors.
 * @param {unknown} error
 * @returns {number | undefined}
 */
export function getHttpErrorStatus(error) {
    return (
        error?.statusCode ??
        error?.status ??
        error?.response?.status ??
        error?.originalError?.response?.status
    );
}
